import { makeStyles } from "@material-ui/core";
import { color } from "../../../assets/const/color";

export const useStyles = makeStyles(() => ({
  root: {
    "& p": {
      fontFamily: "public sans",
    },
    "& .MuiInputBase-root": {
      borderRadius: "50px",
      fontFamily: "inter !important",
    },
    "& .MuiButton-root:hover": {
      background: `${color.lightGreen} !important`,
      color: `${color.white} !important`,
    },
  },
  download_btn: {
    textTransform: "capitalize !important",
    fontFamily: "inter !important",
    fontWeight: "700 !important",
    color: `${color.white} !important`,
    background: `${color.lightGreen} !important`,
    borderRadius: "10px !important",
  },
  input_label: {
    fontFamily: "inter !important",
    fontSize: "18px !important",
    color: "#222222",
  },
  submit_btn: {
    textTransform: "capitalize !important",
    fontFamily: "inter !important",
    color: `${color.white} !important`,
    background: `${color.lightGreen} !important`,
  },
  error: {
    color: "red",
    fontSize: "12px",
  },
  attendanceForm: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: "16px",
  },
}));
